import React from 'react';
import { buttonStyles } from '../../styles/tailwind.classes';

const Button = ({ 
  variant = 'primary', 
  disabled = false, 
  className = '', 
  children, 
  ...props 
}) => {
  const baseClasses = buttonStyles.base;
  const variantClasses = disabled ? buttonStyles.disabled : buttonStyles[variant];
  
  return (
    <button
      className={`${baseClasses} ${variantClasses} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button; 